import { ICON_HEIGHT_24 } from '../../Icon'
import { NavArrows } from '../../NavArrow'
import { Skeleton } from '../../Skeleton'
import Text from '../../Text'

import {
  ENTITY_PROFILE_NAVIGATION_BASE_VALUE,
  QA_NAME_ENTITY_PROFILE_NAVIGATION_NEXT,
  QA_NAME_ENTITY_PROFILE_NAVIGATION_PREV,
} from './EntityProfileNavigation.constants'

import * as styles from './EntityProfileNavigation.module.css'

function EntityProfileNavigation({
  arrowsClassName,
  className = styles.EntityProfileNavigation,
  counterText,
  disabled,
  hasNext,
  hasPrevious,
  isSkeleton,
  nextTooltip,
  previousTooltip,
  size = ICON_HEIGHT_24,
  tooltipPlacement,
  onNext,
  onPrevious,
}) {
  function handleChange(nextValue) {
    if (nextValue > ENTITY_PROFILE_NAVIGATION_BASE_VALUE) {
      onNext()
    } else {
      onPrevious()
    }
  }

  return (
    <div className={className}>
      {isSkeleton ? (
        <Skeleton className={styles.skeleton} />
      ) : (
        <>
          {counterText ? <Text isSecondary>{counterText}</Text> : null}
          <NavArrows
            className={arrowsClassName}
            disabled={disabled}
            nextActionProps={{
              disabled: !hasNext,
              isGrey: true,
              qaName: QA_NAME_ENTITY_PROFILE_NAVIGATION_NEXT,
              tooltip: nextTooltip,
              tooltipPlacement,
            }}
            prevActionProps={{
              disabled: !hasPrevious,
              isGrey: true,
              qaName: QA_NAME_ENTITY_PROFILE_NAVIGATION_PREV,
              tooltip: previousTooltip,
              tooltipPlacement,
            }}
            size={size}
            value={ENTITY_PROFILE_NAVIGATION_BASE_VALUE}
            onChange={handleChange}
          />
        </>
      )}
    </div>
  )
}

export default EntityProfileNavigation
